export const GAME_CONFIG_DIVER_FAST = {
    skinId: 'diver-fast',
    progressDuration: 5_000,
    colors: ['#E50439', '#FEB62A' , '#0AA46C', '#097BFD', '#2FE3D1'],
    chat: 'hide',
};